import makeStyles from '@mui/styles/makeStyles'

const bp = 'sm'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    flexDirection: 'column',
    marginBottom: '0.75rem',
    width: '100%'
  },

  inputArea: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '1rem',

    [theme.breakpoints.down(bp)]: {
      marginTop: '2rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: '0'
    }
  },

  inputHolder: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    flex: '1',

    [theme.breakpoints.down(bp)]: {
      marginLeft: '0'
    },
    '& .selected-flag': {
      paddingLeft: 0
    }
  },

  shield: {
    position: 'absolute',
    top: '50%',
    left: '-1.25rem',
    transform: 'translateY(-50%)',
    color: theme.palette.primary.main,
    height: '1rem',
    width: '1rem',

    [theme.breakpoints.down('sm')]: {
      left: '0',
      transform: 'translateY(100%)'
    }
  },

  error: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',

    [theme.breakpoints.down(960)]: {
      marginTop: '0.5rem'
    },

    [theme.breakpoints.up(960)]: {
      marginBottom: '0.75rem'
    },

    '& .icon': {
      marginRight: '0.25rem',
      color: '#B8960C',
      height: '1rem',
      width: '1rem'
    }
  }
}))

export default useStyles
